import React from "react";

const Hero = () => {
  return (
    <>
      <div class="home">
        <div class="home_slider_container">
          <div class="owl-carousel owl-theme home_slider">
            <div class="owl-item">
              <div class="background_image backcov"></div>
              <div class="home_container">
                <div class="home_container_inner d-flex flex-column align-items-center justify-content-center">
                  <div class="home_content text-center">
                    <div class="home_subtitle">New single release</div>
                    <div class="home_title">
                      <h1>Slow Down</h1>
                    </div>
                    <div class="home_link">
                      <a href="#">Listen on All Streaming Platforms</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="owl-item">
              <div class="background_image backcov"></div>
              <div class="home_container">
                <div class="home_container_inner d-flex flex-column align-items-center justify-content-center">
                  <div class="home_content text-center">
                    <div class="home_subtitle">New single release</div>
                    <div class="home_title">
                      <h1>Slow Down</h1>
                    </div>
                    <div class="home_link">
                      <a href="#">Listen on All Streaming Platforms</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="owl-item">
              <div class="background_image backcov"></div>
              <div class="home_container">
                <div class="home_container_inner d-flex flex-column align-items-center justify-content-center">
                  <div class="home_content text-center">
                    <div class="home_subtitle">New single release</div>
                    <div class="home_title">
                      <h1>Slow Down</h1>
                    </div>
                    <div class="home_link">
                      <a href="#">Listen on All Streaming Platforms</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
